<div #dropdownElement class="dropdown-container">
  <div (click)="isOpen ? closeDropdown() : openDropdown()">
    <ng-content select=".dropdown-toggle"></ng-content>
  </div>

  @if (isOpen) {
    <div id="dropdown" class="dropdown" [ngClass]="[direction, type]">
      <ng-content select=".dropdown-content"></ng-content>
    </div>
  }
</div>
